import {Typography} from '@/components/Typography';
import {palette} from '@/styles';
import {GrayCenterBox} from '../StyledComponents';
import {EMPTY_ITEM_TYPES} from './constants';

export const EmptyItem = ({type}: {type: EMPTY_ITEM_TYPES}) => {
  return (
    <GrayCenterBox>
      <Typography variant="medium12" color={palette.gray600}>
        {type === EMPTY_ITEM_TYPES.Population
          ? '인구 정보가 없습니다.'
          : '매출 정보가 없습니다.'}
      </Typography>
      <Typography variant="medium12" color={palette.gray400} align="center">
        {type === EMPTY_ITEM_TYPES.Population
          ? '데이터 기준일 현재 해당하는'
          : '데이터 기준일 현재 해당 업종 매장의'}
        <br />
        {type === EMPTY_ITEM_TYPES.Population
          ? '인구 정보가 확인되지 않습니다.'
          : '매출 정보가 확인되지 않습니다.'}
      </Typography>
    </GrayCenterBox>
  );
};
